import React from 'react';
import { simulations } from '../simulations';

interface BiasSimulationProps {
  simulation: string;
}

export const BiasSimulation: React.FC<BiasSimulationProps> = ({ simulation }) => {
  const SimulationComponent = simulations[simulation];

  if (!SimulationComponent) {
    return (
      <div className="w-full h-64 flex items-center justify-center">
        <div className="text-center">
          <div className="text-gray-600">
            Interactive example coming soon...
          </div>
          <div className="text-sm text-gray-500 mt-1">
            We're working on creating an engaging simulation for this bias
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full overflow-x-hidden">
      <SimulationComponent />
    </div>
  );
}; 